var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "invoice-table" },
    [
      _c("div", { staticClass: "label-container" }, [
        _vm.rowData.isfHsCode != undefined || _vm.rowData.isfHsCode != null
          ? _c(
              "div",
              {
                staticClass: "label-item",
                staticStyle: { "margin-left": "-40px" },
              },
              [
                _c("div", { staticClass: "label-mark" }, [_vm._v("ISF税号")]),
                _c(
                  "el-tooltip",
                  {
                    attrs: { content: _vm.rowData.isfHsCode, placement: "top" },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "label-info",
                        staticStyle: {
                          "max-width": "140px",
                          flex: "1",
                          "white-space": "nowrap",
                          overflow: "hidden",
                          "text-overflow": "ellipsis",
                        },
                      },
                      [_vm._v(" " + _vm._s(_vm.rowData.isfHsCode) + " ")]
                    ),
                  ]
                ),
              ],
              1
            )
          : _vm._e(),
        _c("div", { staticClass: "label-item" }, [
          _c("div", { staticClass: "label-mark" }, [_vm._v("主单号")]),
          _c("div", { staticClass: "label-info" }, [
            _vm._v(_vm._s(_vm.rowData.mblNo)),
          ]),
        ]),
        _vm.rowData.containerNo
          ? _c(
              "div",
              { staticClass: "label-item" },
              [
                _c("div", { staticClass: "label-mark" }, [_vm._v("柜号")]),
                _c(
                  "el-tooltip",
                  {
                    attrs: {
                      content: _vm.rowData.containerNo,
                      placement: "top",
                    },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "label-info",
                        staticStyle: {
                          "max-width": "190px",
                          flex: "1",
                          "white-space": "nowrap",
                          overflow: "hidden",
                          "text-overflow": "ellipsis",
                        },
                      },
                      [_vm._v(" " + _vm._s(_vm.rowData.containerNo) + " ")]
                    ),
                  ]
                ),
              ],
              1
            )
          : _vm._e(),
        _c("div", { staticClass: "label-item" }, [
          _c("div", { staticClass: "label-mark" }, [_vm._v("提单件数")]),
          _c("div", { staticClass: "label-info" }, [
            _vm._v(_vm._s(_vm.rowData.qty)),
          ]),
        ]),
        _c("div", { staticClass: "label-item" }, [
          _c("div", { staticClass: "label-mark" }, [_vm._v("提单重量")]),
          _c("div", { staticClass: "label-info" }, [
            _vm._v(_vm._s(_vm.rowData.weightKgs)),
          ]),
        ]),
        !_vm.isShowBack
          ? _c("div", { staticClass: "showTax" }, [
              _c("span", [_vm._v("总税金")]),
              _c("span", { staticClass: "num" }, [
                _vm._v(_vm._s(isNaN(_vm.sumData) ? 0 : _vm.sumData)),
              ]),
            ])
          : _vm._e(),
        !_vm.isShowBack
          ? _c("div", { staticClass: "showTax" }, [
              _c("span", [_vm._v("总杂费")]),
              _c("span", { staticClass: "num" }, [
                _vm._v(
                  _vm._s(isNaN(_vm.incidentalsData) ? 0 : _vm.incidentalsData)
                ),
              ]),
            ])
          : _vm._e(),
        _vm.isShowBack
          ? _c("div", { staticClass: "back", on: { click: _vm.cancel } }, [
              _c("img", {
                attrs: { src: require("@/assets/images/bill/back.png") },
              }),
              _vm._v(" 返回 "),
            ])
          : _vm._e(),
        _vm._m(0),
      ]),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          ref: "invoiceData",
          staticClass: "invoice-table-container",
          attrs: {
            data: _vm.invoiceData,
            "header-cell-style": _vm.headerCellStyle,
            "cell-class-name": _vm.cellClassName,
            height: _vm.height,
            border: true,
            "show-summary": "",
            "summary-method": _vm.getSummaries,
            "cell-style": _vm.cellStyle,
          },
          on: {
            "cell-click": _vm.cellclick,
            "cell-dblclick": _vm.cellDblclick,
            "selection-change": _vm.selectionchange,
          },
        },
        [
          _vm.isOpt
            ? _c("el-table-column", {
                attrs: {
                  type: "selection",
                  width: "40",
                  selectable: _vm.selectable,
                },
              })
            : _vm._e(),
          _c("el-table-column", {
            attrs: { type: "index", label: "序号", fixed: "left", width: "55" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(" " + _vm._s(scope.$index + 1) + " "),
                    scope.row.operationType === 0 ||
                    scope.row.operationType === 1
                      ? _c(
                          "span",
                          {
                            staticClass: "row-tips",
                            class: _vm.bgColor(scope.row),
                          },
                          [
                            _vm._v(
                              _vm._s(
                                scope.row.operationType === 0 ? "增" : "删"
                              )
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
          _vm._l(_vm.fileds, function (item, $index) {
            return _c("el-table-column", {
              key: $index,
              attrs: {
                prop: item.filed,
                label: item.text,
                width: item.width,
                fixed: item.fixed,
                align: item.align,
                "show-overflow-tooltip": "",
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "header",
                    fn: function (scope) {
                      return [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "align-items": "center",
                            },
                          },
                          [
                            _vm._v(" " + _vm._s(scope.column.label) + " "),
                            item.filed === "nameCH" || item.filed === "hsCode"
                              ? _c(
                                  "span",
                                  { staticClass: "doubleClick" },
                                  [
                                    _c("svg-icon", {
                                      attrs: {
                                        title: "双击",
                                        iconClass: "doubleClick",
                                        className: "icon",
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ]
                        ),
                      ]
                    },
                  },
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        item.filed === "opt"
                          ? [
                              scope.row.isEdit
                                ? _c("img", {
                                    staticStyle: { cursor: "pointer" },
                                    attrs: {
                                      src: require("@/assets/images/bill/unlock.png"),
                                    },
                                    on: {
                                      click: function ($event) {
                                        scope.row.isEdit = !scope.row.isEdit
                                      },
                                    },
                                  })
                                : _c("img", {
                                    staticStyle: { cursor: "pointer" },
                                    attrs: {
                                      src: require("@/assets/images/bill/lock.png"),
                                    },
                                    on: {
                                      click: function ($event) {
                                        scope.row.isEdit = !scope.row.isEdit
                                      },
                                    },
                                  }),
                            ]
                          : item.filed === "isAluminumLicenseOrSteelLicense"
                          ? [
                              scope.row.isAluminumLicense ||
                              scope.row.isSteelLicense
                                ? _c("span", [_vm._v("99039101")])
                                : _vm._e(),
                            ]
                          : item.filed === scope.row.editFiled && _vm.isOpt
                          ? [
                              _c(
                                _vm.getComponent(item.filed),
                                _vm._b(
                                  {
                                    tag: "component",
                                    attrs: { size: "mini", controls: false },
                                    on: {
                                      blur: function ($event) {
                                        return _vm.filedChange(
                                          scope.row,
                                          scope.$index
                                        )
                                      },
                                      change: function ($event) {
                                        return _vm.filedChange(
                                          scope.row,
                                          scope.$index
                                        )
                                      },
                                    },
                                    model: {
                                      value: scope.row[item.filed],
                                      callback: function ($$v) {
                                        _vm.$set(scope.row, item.filed, $$v)
                                      },
                                      expression: "scope.row[item.filed]",
                                    },
                                  },
                                  "component",
                                  _vm.getInputProps(item.filed),
                                  false
                                )
                              ),
                            ]
                          : item.filed === "hsCode"
                          ? [
                              _vm._v(" " + _vm._s(scope.row[item.filed]) + " "),
                              scope.row.isSteelLicense
                                ? _c("img", {
                                    staticStyle: { "vertical-align": "-4px" },
                                    attrs: {
                                      src: require("@/assets/images/bill/tie.png"),
                                    },
                                  })
                                : _vm._e(),
                              scope.row.isAluminumLicense
                                ? _c("img", {
                                    staticStyle: { "vertical-align": "-4px" },
                                    attrs: {
                                      src: require("@/assets/images/bill/lv.png"),
                                    },
                                  })
                                : _vm._e(),
                              scope.row?.editJson?.length &&
                              _vm.ifHisTory(scope.row?.editJson, item.filed)
                                ? _c(
                                    "el-popover",
                                    {
                                      attrs: {
                                        placement: "right",
                                        trigger: "hover",
                                        effect: "dark",
                                        "popper-class": "popper_tooltip",
                                        content: `修改前记录：${
                                          _vm.formatHistory(
                                            scope.row?.editJson,
                                            item
                                          )?.oldValue
                                        }`,
                                      },
                                    },
                                    [
                                      _c("template", { slot: "reference" }, [
                                        _c("span", [
                                          _vm.formatHistory(
                                            scope.row?.editJson,
                                            item
                                          )
                                            ? _c("img", {
                                                staticClass: "history",
                                                attrs: {
                                                  src: require("@/assets/images/table/history.png"),
                                                },
                                              })
                                            : _vm._e(),
                                        ]),
                                      ]),
                                    ],
                                    2
                                  )
                                : _vm._e(),
                            ]
                          : _vm.isBatchField(item.filed)
                          ? [
                              _vm.getExemptFlag(scope.row, item.filed)
                                ? _c("svg-icon", {
                                    staticStyle: {
                                      width: "2em",
                                      height: "1em",
                                    },
                                    attrs: {
                                      title: "豁免",
                                      "icon-class": "exempt",
                                      "class-name": "icon",
                                    },
                                  })
                                : _vm._e(),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.getBatchValue(scope.row, item.filed)
                                  ) +
                                  " "
                              ),
                              scope.row?.editJson?.length &&
                              _vm.ifHisTory(scope.row?.editJson, item.filed)
                                ? _c(
                                    "el-popover",
                                    {
                                      attrs: {
                                        placement: "right",
                                        trigger: "hover",
                                        effect: "dark",
                                        "popper-class": "popper_tooltip",
                                        content: `修改前记录：${
                                          _vm.formatHistory(
                                            scope.row?.editJson,
                                            item
                                          )?.oldValue
                                        }`,
                                      },
                                    },
                                    [
                                      _c("template", { slot: "reference" }, [
                                        _c("span", [
                                          _vm.formatHistory(
                                            scope.row?.editJson,
                                            item
                                          )
                                            ? _c("img", {
                                                staticClass: "history",
                                                attrs: {
                                                  src: require("@/assets/images/table/history.png"),
                                                },
                                              })
                                            : _vm._e(),
                                        ]),
                                      ]),
                                    ],
                                    2
                                  )
                                : _vm._e(),
                            ]
                          : item.filed === "totalAmount"
                          ? [
                              _c(
                                "el-popover",
                                {
                                  attrs: {
                                    placement: "top-start",
                                    width: "auto",
                                    trigger: "hover",
                                  },
                                },
                                [
                                  _c(
                                    "pre",
                                    { staticStyle: { "font-weight": "bold" } },
                                    [_vm._v(_vm._s(scope.row.dutyFormula))]
                                  ),
                                  _c("i", {
                                    staticClass: "el-icon-warning",
                                    staticStyle: {
                                      "margin-right": "3px",
                                      color: "black",
                                    },
                                    attrs: { slot: "reference" },
                                    slot: "reference",
                                  }),
                                ]
                              ),
                              _vm._v(" " + _vm._s(scope.row[item.filed]) + " "),
                            ]
                          : [
                              _vm._v(" " + _vm._s(scope.row[item.filed]) + " "),
                              scope.row?.editJson?.length &&
                              _vm.ifHisTory(scope.row?.editJson, item.filed)
                                ? _c(
                                    "el-popover",
                                    {
                                      attrs: {
                                        placement: "right",
                                        trigger: "hover",
                                        effect: "dark",
                                        "popper-class": "popper_tooltip",
                                        content: `修改前记录：${
                                          _vm.formatHistory(
                                            scope.row?.editJson,
                                            item
                                          )?.oldValue
                                        }`,
                                      },
                                    },
                                    [
                                      _c("template", { slot: "reference" }, [
                                        _c("span", [
                                          _vm.formatHistory(
                                            scope.row?.editJson,
                                            item
                                          )
                                            ? _c("img", {
                                                staticClass: "history",
                                                attrs: {
                                                  src: require("@/assets/images/table/history.png"),
                                                },
                                              })
                                            : _vm._e(),
                                        ]),
                                      ]),
                                    ],
                                    2
                                  )
                                : _vm._e(),
                            ],
                      ]
                    },
                  },
                ],
                null,
                true
              ),
            })
          }),
        ],
        2
      ),
      _vm.isOpt && !_vm.isCheck
        ? _c(
            "div",
            { staticClass: "bottom", staticStyle: { "padding-top": "15px" } },
            [
              _vm.$store.state.caches?.length > 0
                ? _c(
                    "el-button",
                    { staticClass: "btn prev", on: { click: _vm.prev } },
                    [_vm._v(" 上一步 ")]
                  )
                : _vm._e(),
              _c(
                "el-button",
                {
                  staticClass: "btn export",
                  attrs: { loading: _vm.loading },
                  on: { click: _vm.exportInvoice },
                },
                [_vm._v("导 出")]
              ),
              _vm.controlOverInvoicesId > 0
                ? _c(
                    "el-button",
                    {
                      staticClass: "btn restore",
                      attrs: { loading: _vm.loading },
                      on: { click: _vm.restore },
                    },
                    [_vm._v("版本还原")]
                  )
                : _vm._e(),
              _c(
                "el-button",
                {
                  staticClass: "btn ok",
                  attrs: { loading: _vm.loading },
                  on: { click: _vm.determineok },
                },
                [_vm._v(" " + _vm._s(_vm.isShowBack ? "确 定" : "通 过") + " ")]
              ),
              _c(
                "el-button",
                { staticClass: "btn ok", on: { click: _vm.sdfk } },
                [_vm._v("审单反馈")]
              ),
              _c("div", { staticClass: "footer" }, [
                _c("div", { staticClass: "btn1", on: { click: _vm.merge } }, [
                  _c("img", {
                    attrs: { src: require("@/assets/images/bill/merge.png") },
                  }),
                  _vm._v("合并行 "),
                ]),
                _c(
                  "div",
                  { staticClass: "btn1", on: { click: _vm.deleteRow } },
                  [
                    _c("img", {
                      attrs: {
                        src: require("@/assets/images/bill/delete.png"),
                      },
                    }),
                    _vm._v("删除行 "),
                  ]
                ),
                _c("div", { staticClass: "btn1", on: { click: _vm.addRow } }, [
                  _c("img", {
                    attrs: { src: require("@/assets/images/bill/addRow.png") },
                  }),
                  _vm._v("新增行 "),
                ]),
                _c(
                  "div",
                  { staticClass: "btn1 edit", on: { click: _vm.editRow } },
                  [
                    _c("img", {
                      attrs: {
                        src: require("@/assets/images/bill/unlock.png"),
                      },
                    }),
                    _vm._v("可编辑 "),
                  ]
                ),
                _c(
                  "div",
                  { staticClass: "btn1 unedit", on: { click: _vm.uneditRow } },
                  [
                    _c("img", {
                      attrs: { src: require("@/assets/images/bill/lock.png") },
                    }),
                    _vm._v("不可编辑 "),
                  ]
                ),
                _c("span", [
                  _vm._v("已选择 "),
                  _c("span", { staticClass: "length" }, [
                    _vm._v(_vm._s(_vm.selections.length)),
                  ]),
                  _vm._v(" 项"),
                ]),
                _c("div", { staticClass: "break" }),
              ]),
            ],
            1
          )
        : _vm._e(),
      _c("MergeDialog", {
        attrs: {
          dialogVisible: _vm.dialogVisible3,
          mergeSelections: _vm.selections,
        },
        on: {
          ok: _vm.mergeOk,
          cancel: function ($event) {
            _vm.dialogVisible3 = false
          },
        },
      }),
      _c("ProductDialog", {
        attrs: { dialogVisible: _vm.dialogVisible },
        on: {
          ok: _vm.productOk,
          cancel: function ($event) {
            _vm.dialogVisible = false
          },
        },
      }),
      _c("TaxDialog", {
        attrs: { dialogVisible: _vm.dialogVisible2 },
        on: {
          ok: _vm.taxOk,
          cancel: function ($event) {
            _vm.dialogVisible2 = false
          },
        },
      }),
      _c("AddProductDialog", {
        attrs: { dialogVisible: _vm.dialogVisible4 },
        on: {
          ok: _vm.addOk,
          cancel: function ($event) {
            _vm.dialogVisible4 = false
          },
        },
      }),
      _c(
        "el-dialog",
        {
          directives: [{ name: "drag", rawName: "v-drag" }],
          staticClass: "dialog",
          attrs: {
            "append-to-body": "",
            visible: _vm.sdfkdialogVisible,
            title: "审单反馈",
            width: "36%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.sdfkdialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "form",
              staticStyle: { "margin-left": "25px" },
              attrs: { model: _vm.form, rules: _vm.rules },
            },
            [
              _c(
                "el-form-item",
                {
                  staticStyle: { "margin-top": "-15px" },
                  attrs: { label: "上传反馈文件", prop: "filePath" },
                },
                [
                  _vm._v("("),
                  _c("span", { staticStyle: { color: "red" } }, [
                    _vm._v("最多上传5个文件"),
                  ]),
                  _vm._v(")"),
                  _c("br"),
                  _c(
                    "el-upload",
                    {
                      staticClass: "upload-demo",
                      attrs: {
                        action: `/api/ControlOverInvoices/uploadInvoiceReviewFile`,
                        drag: "",
                        "on-success": _vm.handleSuccess,
                        "before-upload": _vm.beforeUpload,
                        "on-progress": _vm.onProgress,
                        "show-file-list": false,
                      },
                    },
                    [
                      _c("i", { staticClass: "el-icon-plus" }),
                      _c("div", { staticClass: "el-upload__text" }, [
                        _vm._v("拖拽或"),
                        _c("em", [_vm._v("点击上传")]),
                      ]),
                    ]
                  ),
                  _c(
                    "div",
                    { staticClass: "fileList" },
                    _vm._l(_vm.fileList, function (item, index) {
                      return _c(
                        "div",
                        { key: index, staticClass: "fileItem flex_c_c" },
                        [
                          _c("div", { staticClass: "left" }, [
                            _c("div", { staticClass: "file" }, [
                              _c(
                                "p",
                                {
                                  staticClass: "fileName",
                                  attrs: { title: item.fileName },
                                },
                                [_vm._v(" " + _vm._s(item.fileName) + " ")]
                              ),
                              _c("p", { staticClass: "fileSize" }, [
                                _vm._v(
                                  _vm._s(_vm.filterSize(item.fileSize)) + " MB"
                                ),
                              ]),
                            ]),
                          ]),
                          _c("div", { staticClass: "opt" }, [
                            _c("img", {
                              attrs: {
                                src: require("@/assets/images/bill/review.png"),
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.review(item)
                                },
                              },
                            }),
                            _c("img", {
                              attrs: {
                                src: require("@/assets/images/bill/deleteFile.png"),
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.deleteFile(index)
                                },
                              },
                            }),
                          ]),
                        ]
                      )
                    }),
                    0
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticStyle: { "margin-top": "-15px" },
                  attrs: { label: "建议", prop: "advice" },
                },
                [
                  _vm.rowData.reviewFeedback
                    ? _c(
                        "el-popover",
                        {
                          attrs: {
                            placement: "right-start",
                            width: "auto",
                            trigger: "hover",
                          },
                        },
                        [
                          _c("pre", [
                            _vm._v(_vm._s(_vm.rowData.reviewFeedback)),
                          ]),
                          _c(
                            "el-button",
                            {
                              staticStyle: {
                                background: "rgba(165, 90, 248, 0.1)",
                                color: "#a55af8",
                              },
                              attrs: {
                                slot: "reference",
                                icon: "el-icon-chat-dot-round",
                                size: "mini",
                                round: "",
                              },
                              slot: "reference",
                            },
                            [_vm._v("最新反馈记录")]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c("br"),
                  _c("el-input", {
                    staticStyle: { width: "580px" },
                    attrs: {
                      type: "textarea",
                      rows: 4,
                      placeholder: "请输入内容",
                    },
                    model: {
                      value: _vm.form.advice,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "advice", $$v)
                      },
                      expression: "form.advice",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.sdfkcancer } }, [
                _vm._v("取 消"),
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.loading },
                  on: { click: _vm.ok },
                },
                [_vm._v("确 认")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          directives: [{ name: "drag", rawName: "v-drag" }],
          staticClass: "dialog",
          attrs: {
            "append-to-body": "",
            visible: _vm.showCopperDialog,
            title: `确定为选中的${_vm.selections.length}条数据添加钢铝铜豁免附加税吗？`,
            width: "24%",
            "close-on-click-modal": false,
            "lock-scroll": true,
          },
          on: {
            "update:visible": function ($event) {
              _vm.showCopperDialog = $event
            },
          },
          scopedSlots: _vm._u([
            {
              key: "footer",
              fn: function () {
                return [
                  _c(
                    "span",
                    { staticClass: "dialog-footer" },
                    [
                      _c(
                        "el-button",
                        {
                          on: {
                            click: function ($event) {
                              _vm.showCopperDialog = false
                            },
                          },
                        },
                        [_vm._v("取消")]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.confirmCopperAction },
                        },
                        [_vm._v("确定")]
                      ),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _c(
            "el-radio-group",
            {
              model: {
                value: _vm.batchNoThreeExempt,
                callback: function ($$v) {
                  _vm.batchNoThreeExempt = $$v
                },
                expression: "batchNoThreeExempt",
              },
            },
            [
              _c("el-radio", { attrs: { label: "99038203" } }, [
                _vm._v("豁免批次99038203"),
              ]),
              _c("el-radio", { attrs: { label: "99038213" } }, [
                _vm._v("豁免批次99038213"),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "tips" }, [
      _c("span", { staticClass: "qun green" }),
      _vm._v(" 客户修改 "),
      _c("span", { staticClass: "qun red" }),
      _vm._v(" 后台修改 "),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }